import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
/**
 * Diálogo modal sobre <dialog> nativo: ganha Esc, foco preso e camada de topo sem código extra.
 */
export function Modal({ aberto, titulo, descricao, onFechar, children, acoes, largura = 'media', alturaCheia = false, }) {
    const ref = useRef(null);
    useEffect(() => {
        const dialog = ref.current;
        if (!dialog)
            return;
        if (aberto && !dialog.open)
            dialog.showModal();
        if (!aberto && dialog.open)
            dialog.close();
    }, [aberto]);
    return (_jsxs("dialog", { ref: ref, onCancel: (e) => {
            e.preventDefault();
            onFechar();
        }, onClick: (e) => {
            // Clique no backdrop (fora do conteúdo) fecha.
            if (e.target === ref.current)
                onFechar();
        }, className: `w-[calc(100vw-2rem)] rounded-card border border-neutral-200 bg-white p-0 text-neutral-900 backdrop:bg-black/40 dark:border-neutral-800 dark:bg-neutral-900 dark:text-neutral-100 ${largura === 'cheia' ? 'max-w-6xl' : largura === 'larga' ? 'max-w-3xl' : 'max-w-lg'}`, children: [_jsxs("div", { className: alturaCheia
                    ? 'flex h-[85vh] flex-col overflow-hidden p-6'
                    : 'max-h-[85vh] overflow-y-auto p-6', children: [_jsx("h2", { className: "text-lg font-semibold", children: titulo }), descricao && _jsx("p", { className: "mt-1 text-sm text-neutral-500", children: descricao }), _jsx("div", { className: alturaCheia ? 'mt-4 flex min-h-0 flex-1 flex-col' : 'mt-4', children: children })] }), acoes && (_jsx("div", { className: "flex justify-end gap-2 border-t border-neutral-200 p-4 dark:border-neutral-800", children: acoes }))] }));
}
//# sourceMappingURL=Modal.js.map